/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
import React from 'react'
import AutoComplete from '@components/base/autoComplete/AutoComplete'

//system components
import './DVLASection.css'

const DVLA_FIELDS = {
  make: {
    fieldValue: 'make',
    dataTestId: 'ddl_manual_review_make',
  },
  category: {
    fieldValue: 'category',
    dataTestId: 'ddl_manual_review_category',
  },
  color: {
    fieldValue: 'color',
    dataTestId: 'ddl_manual_review_color',
  },
}

const DVLASection = ({
  labels,
  values,
  options,
  onChange,
  observationDetails,
}) => {
  const renderAutocomplete = (key) => {
    const fieldMeta = DVLA_FIELDS?.[key]
    if (!fieldMeta) {
      return <dd>{values?.[key]}</dd>
    }

    return (
      <dd className="dvla-dropdown-wrapper">
        <AutoComplete
          dataTestId={fieldMeta?.dataTestId}
          field={{
            fieldValue: fieldMeta?.fieldValue,
            fieldLabel: '',
            dataSource: options?.[key] || [],
            textField: 'name',
            valueField: 'name',
            className: 'dvla-autocomplete colWiseControl',
            isSelect: false,
            placeholder: `Select ${labels?.[key] || ''}`,
            disabled: observationDetails?.taskStatus == 'Issued',
            popperClassName: `decreasePopperHeight`,
          }}
          value={values?.[key] || ''}
          onChangeHandler={(event, params) => {
            if (onChange) {
              onChange(key, params?.value)
            }
          }}
        />
      </dd>
    )
  }

  return (
    <div className="dvla-section">
      <h2 className="section-title">DVLA VES Lookup</h2>
      <dl className="dvla-info-container">
        {Object.keys(labels).map((key) => (
          <div key={key} className="NoticeDetailRow">
            <dt>{labels[key]}</dt>
            {renderAutocomplete(key)}
          </div>
        ))}
      </dl>
    </div>
  )
}

export default DVLASection
